module.exports = __webpack_public_path__ + "img/djj2.87abe688.png";